import { useQuery } from "@tanstack/react-query";
import { faqApi } from "./api";

export const useFaqs = (params?: Parameters<typeof faqApi.getFaqs>[0]) => {
  return useQuery({
    queryKey: ["faq", params ?? { limit: 50, offset: 0, is_published: true }],
    queryFn: () => faqApi.getFaqs(params),
    retry: false,
  });
};

